"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BanUserFromCommunityBodyToJSON = exports.BanUserFromCommunityBodyFromJSONTyped = exports.BanUserFromCommunityBodyFromJSON = void 0;
function BanUserFromCommunityBodyFromJSON(json) {
    return BanUserFromCommunityBodyFromJSONTyped(json, false);
}
exports.BanUserFromCommunityBodyFromJSON = BanUserFromCommunityBodyFromJSON;
function BanUserFromCommunityBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'groupingId': json['groupingId'],
    };
}
exports.BanUserFromCommunityBodyFromJSONTyped = BanUserFromCommunityBodyFromJSONTyped;
function BanUserFromCommunityBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'groupingId': value.groupingId,
    };
}
exports.BanUserFromCommunityBodyToJSON = BanUserFromCommunityBodyToJSON;
